import { Injectable } from '@angular/core';
import {
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router';

import { StorageService } from '@services/Logic/storage.service';
import { AuthService } from '../http/auth.service';
import { ExternalLinksService } from '@services/Logic/externalLinks.service';

@Injectable()
export class AuthGuard {
  constructor(
    private router: Router,
    private authService: AuthService,
  ) {}
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const queryToken = route.queryParams['token'];
    if (queryToken) {
      this.authService.authenticateIfNecessary(queryToken);
    }
    if (this.authService.isAuthenticated()) {
      return true;
    }
    // Persistent URL after auth
    const redirectUrl = window.location.pathname + window.location.search;
    this.router.navigate(['/'], {
      queryParams: {
        authDialog: true,
        redirectUrl,
      },
    });
    return false;
  }
}

@Injectable()
export class AuthSuccessGuardRedirect {
  constructor(
    private router: Router,
    private authService: AuthService,
    private externalLinksService: ExternalLinksService,
    private storage: StorageService,
  ) {}

  canActivate() {
    if (this.authService.isAuthenticated()) {
      const ppOrTo = this.storage?.user?.pinployeeOrTaskOwner;
      if (ppOrTo !== 'pp') {
        return this.router.navigate(['/udforsk']);
      }
      return this.router.navigate(['/opgaver']);
    }
    this.externalLinksService.goToPage('landing');
    return false;
  }
}

@Injectable()
export class PreventLoginGuard {
  constructor(
    private router: Router,
    private authService: AuthService,
    private storage: StorageService,
  ) {}

  canActivate() {
    if (!this.authService.isAuthenticated()) {
      return true;
    }
    const redirectUrl = new URLSearchParams(window.location.search).get(
      'redirectUrl',
    );
    if (redirectUrl) {
      this.router.navigateByUrl(redirectUrl);
    } else {
      const ppOrTo = this.storage?.user?.pinployeeOrTaskOwner;
      if (ppOrTo !== 'pp') {
        this.router.navigate(['/udforsk']);
      } else {
        this.router.navigate(['/opgaver']);
      }
    }
    return false;
  }
}
